import { type ServiceMethod } from '@/application/interfaces/service';

type Params = {
  cartId: string;
};

export type AvailablePaymentMethods = {
  bank_slip: boolean;
  pix: boolean;
  credit_card: boolean;
};

export type Response = {
  data: AvailablePaymentMethods;
};

const getAvailablePaymentMethods: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { cartId } = data;

    const { body: response } = await httpClient.get<Response, Params>(
      '/api/v3/carts/{cartId}/available-payment-methods',
      {
        ...options,
        params: { cartId },
      }
    );

    return response;
  };

export default getAvailablePaymentMethods;
